import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { theme } from '@marriott/mi-ui-library-shop';

// here added padding-top, that is only applied for mobile screens, becoz
// for tablet & desktop screens added pt-md-5 class
export const StyledMerchandisingSmallBannerUpgraded = styled.div`
  padding-top: clamp(${toRem(62)}, calc(${toRem(62)} + 24 * ((100vw - ${toRem(365)}) / 211)), ${toRem(86)});

  .skeleton-loader-composite {
    background-color: #d2d2d2;
    color: white;
    -webkit-animation: fadein 2s ease-in alternate infinite;
    -moz-animation: fadein 2s ease-in alternate infinite;
    animation: fadein 2s ease-in alternate infinite;
    border-radius: 8px;
  }
  @-webkit-keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
  @-moz-keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
  @keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
  .appdownloadbanner {
    border: ${baseVariables.border['borderWidth02']} solid ${baseVariables.color['neutral20']};
    border-radius: ${baseVariables.border['borderInset02']};
    box-shadow: ${baseVariables.shadows['shadowSubtle01']};
    overflow: hidden;
    &__image {
      width: ${toRem(220)};
      border-radius: ${toRem(6)};
      &-container {
        position: relative;
        top: ${toRem(0)};
        @media ${baseVariables.mediaQuery.md} {
          top: ${toRem(12)};
        }
        max-height: ${toRem(140)};
        @media ${baseVariables.mediaQuery.md} {
          max-height: ${toRem(60)};
        }
      }
    }
    &__qr {
      width: ${toRem(60)};
      height: ${toRem(60)};
    }
  }

  .merchandising-small-banner {
    border: ${baseVariables.border['borderWidth02']} solid ${baseVariables.color['neutral20']};
    border-radius: ${baseVariables.border['borderRadiusDefault']};
    box-shadow: ${baseVariables.shadows['shadowSubtle01']};
    padding: 0 0.5rem 2rem;

    @media ${baseVariables.mediaQuery.md} {
      padding: ${toRem(13)} ${toRem(24)};
    }

    @media ${baseVariables.mediaQuery.lg} {
      padding-left: ${toRem(48)};
      padding-right: ${toRem(77)};
    }

    &__image {
      width: ${toRem(163)};

      @media ${baseVariables.mediaQuery.sm} {
        width: ${toRem(230)};
      }

      @media ${baseVariables.mediaQuery.md} {
        width: ${toRem(117.5)};
      }

      &.withVariation {
        width: ${toRem(180)};
      }

      &-container {
        margin-top: -${toRem(56)};

        &.loading {
          aspect-ratio: 3/2;
          width: ${toRem(155)};
          @media ${baseVariables.mediaQuery.md} {
            width: ${toRem(117.5)};
          }
        }
      }
    }
    &__content {
      width: 100%;
      &_heading {
        del {
          color: ${baseVariables.color['neutral40']};
        }
      }
    }
    &__description,
    .disclaimer-text {
      p {
        margin: 0;
      }
    }

    &__button {
      width: 100%;
      white-space: nowrap;
      @media ${baseVariables.mediaQuery.md} {
        width: auto;
      }
    }

    &__variations {
      .total-amount {
        color: ${baseVariables.color.merch20};
      }
    }
  }

  .merchandising-small-bannerv2 {
    border: ${baseVariables.border['borderWidth02']} solid ${baseVariables.color['neutral20']};
    box-shadow: ${baseVariables.shadows['shadowSubtle01']};
    border-radius: ${toRem(16)};
    @media ${baseVariables.mediaQuery.md} {
      border-radius: ${baseVariables.border['borderInset02']};
    }
    &.withVariation {
      border-radius: ${toRem(14)};
      @media ${baseVariables.mediaQuery.lg} {
        border-radius: ${toRem(8)};
      }
    }

    &__image {
      width: ${toRem(180)};
      position: relative;
      border-radius: ${toRem(6)};

      @media ${baseVariables.mediaQuery.md} {
        width: ${toRem(136)};
        margin-left: -3.5rem;
      }

      &-container {
        margin-top: -${toRem(56)};
        &.withVariation {
          margin-top: -${toRem(48)};
        }

        &.loading {
          aspect-ratio: 3/2;
          width: ${toRem(155)};

          @media ${baseVariables.mediaQuery.md} {
            width: ${toRem(117.5)};
          }
        }
      }
    }

    .bonus-statement-label {
      @media ${baseVariables.mediaQuery.lg} {
        height: 1rem;
      }
    }

    &__content {
      width: 100%;
      &_heading {
        del {
          color: ${baseVariables.color['neutral40']};
        }
      }
    }
    &__border {
      height: ${toRem(86)};
      border: ${toRem(1)} solid ${theme.color['light-gray-3']};
    }
    &__variations {
      .total-amount {
        color: ${baseVariables.color.merch20};
      }
    }
    &__button {
      width: 100%;
      white-space: nowrap;
      @media ${baseVariables.mediaQuery.md} {
        width: auto;
      }

      &-icon {
        height: 1rem;
        width: 1rem;

        &[class*='icon-arrow-']::before {
          padding-right: 0;
          width: 1rem;
          left: 0;
        }
      }

      &:hover .icon-arrow-right-external::before,
      &.focus-visible .icon-arrow-right-external::before,
      &:focus-visible .icon-arrow-right-external::before {
        transform: rotate(-45deg);
        transition: 0.15s all ease-in;
        content: '\e942';
      }
    }
  }

  .icon-arrow-right-external::before {
    font-size: 1rem;
  }
`;
